import { Link, useNavigate, useLocation } from 'react-router-dom'//npm install react-router-dom
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import axios from 'axios'
import { useEffect, useState, useRef } from "react"
import DivBottom from '../userNotAuth/components/divBottom'

function RegisterSuccess() {
    const location = useLocation()
    const navigate = useNavigate()

    const [emailForConfirm, setEmailForConfirm] = useState()
    const [rndCode, setRndCode] = useState()
    const [msg, setMsg] = useState({ codeFailed: false, timeOut: false })
    const formData = useRef()
    const bannerRegSuccess = useRef()
    const bannerForm = useRef()
    const button = useRef()

    function handleChange(e) {
        setMsg({ codeFailed: false })
        const { name, value, type, checked } = e.target
        const inputValue = type === "checkbox" ? checked : value
        if (isNaN(inputValue)) { //inputValue not a number or empty
            document.getElementById("rndCode").value = ''
            return
        }
        formData.current = inputValue
    }
    function handleSubmit(e) {
        e.preventDefault()
        if (rndCode !== parseInt(formData.current)) {
            setMsg({ codeFailed: true })
        }
        else { //accettazione registrazione
            axios.post(`/confirmRegistration/${emailForConfirm}`).then(res => {
                if (res.data === 'Success') {
                    bannerRegSuccess.current.style.left = '2%'
                    bannerForm.current.style.opacity = '0'
                    button.current.disabled = true
                }
            })
        }
    }
    useEffect(() => {
        if (localStorage.getItem('previousPage') !== '/register') {
            navigate('/', { replace: true })
        } else {
            setEmailForConfirm(location.state.emailForConfirm)
            setRndCode(location.state.rndCode)
            localStorage.removeItem('previousPage')
        }
    }, [])
    return (<>
        <NavbarNotAuth />
        <div className='container'>
            <h2 style={{ marginTop: '6rem' }}><b>Registrazione utente</b></h2><hr />
            {
                rndCode && emailForConfirm &&
                <div style={{ marginBottom: '8rem', marginTop: '4rem', transition: '.3s' }} ref={bannerForm}>
                    <h5>Vai in <i>{emailForConfirm}</i> ed inserisci il codice numerico di 5 cifre che hai ricevuto via email.
                    </h5><br />
                    <form onSubmit={handleSubmit}>
                        <input onChange={handleChange} id="rndCode" style={{
                            fontWeight: '600', fontSize: 'large', textAlign: 'center'
                        }}
                            type='text'
                            name='rndCode'
                            required
                            placeholder='*****'
                            minLength={5}
                            maxLength={5} />
                        {msg.codeFailed && <p style={{ color: 'red' }}>
                            <i>Codice errato...riprova.</i></p>}
                        <div className='mt-5'>
                            <button className='btn btn-secondary' type='submit' ref={button}>INVIA</button>
                        </div>
                    </form>
                </div>
            }
            {/* -------------- BANNER ACCETTAZIONE REGISTRAZIONE -------------- */}
            <div style={{
                left: '-100rem', transition: '.3s', position: 'absolute', top: '7rem',
                width: '100%', padding: '1rem'
            }}
                ref={bannerRegSuccess}>
                <br /><br />
                <h1 className='mt-5' style={{
                    margin: '0 auto',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    border: '1px solid black',
                    padding: '10px',
                    width: 'fit-content'
                }}>ZONA EVENTI
                </h1><br />
                <h3 className='mt-4'>Registrazione confermata</h3>
                <h5 className='mt-3'>
                    La tua registrazione è avvenuta con successo.
                    Potrai inserire e modificare i tuoi eventi accedendo alla tua area personale dal
                    <a href="/login"> menù</a> o
                    <Link to={{ pathname: '/login' }}> cliccando qui.</Link>
                </h5><br />
                <div className='mt-2'>
                    <button className='btn btn-primary' onClick={() => {
                        navigate('/login', { replace: true })
                    }}>Login</button>
                </div>
            </div><br />

            {!emailForConfirm &&
                <div className='container' style={{ marginTop: '5rem', marginBottom: '13rem' }}>
                    <h3>Sessione scaduta.<br />
                        Prova a registrarti nuovamente.
                        <Link to={{ pathname: '/register' }}> registrati.</Link>
                    </h3>
                </div>}
        </div>
        <DivBottom />
    </>)
}
export default RegisterSuccess